import { ky } from './ky';
import { CursorListResponse } from './common';

/**
 * 알림 히스토리 DTO. 백엔드 `NotificationHistoryDto`(v1/notification/data)와 매칭된다.
 * 주문 상태 알림(code가 `commerce.order.*`)만 `orderId`가 non-null 이고,
 * 기존 피드 알림(`my.feed.like.acc` 등)은 title/body/linkUrl 기반으로 표시한다.
 */
export interface NotificationHistoryDto {
  id: number;
  code: string;
  title?: string | null;
  body?: string | null;
  linkUrl?: string | null;
  imageUrl?: string | null;
  orderId?: number | null;
  readAt?: string | null;
  createdAt?: string | null;
}

/** 읽지 않은 알림 수 DTO. 백엔드 `UnreadCountDto`와 매칭된다. */
export interface UnreadCountDto {
  count: number;
}

/**
 * 알림 API 클라이언트.
 * 백엔드 `NotificationHistoryController`(/v1/notifications/histories)와 매칭된다. (lone-backend#28)
 * 로그인(멤버) 세션 기준으로 동작하므로 인증 가드가 필요한 화면에서 사용한다.
 */
export default class NotificationService {
  /** 알림 히스토리 커서 기반 조회. cursor는 이전 페이지 응답의 cursor(마지막 알림 id)다. */
  async getHistories(cursor?: number | null, size = 30) {
    const searchParams = new URLSearchParams();
    if (cursor != null) searchParams.append('cursor', String(cursor));
    searchParams.append('size', String(size));
    const response = await ky.get(`v1/notifications/histories?${searchParams.toString()}`);
    return (await response.json()) as CursorListResponse<NotificationHistoryDto>;
  }

  /** 읽지 않은 알림 수 조회 */
  async getUnreadCount() {
    const response = await ky.get('v1/notifications/histories/unread-count');
    return (await response.json()) as UnreadCountDto;
  }

  /** 단건 읽음 처리 */
  async markRead(id: number) {
    await ky.patch(`v1/notifications/histories/${id}/read`);
  }

  /** 모든 알림 읽음 처리 */
  async markAllRead() {
    await ky.patch('v1/notifications/histories/read-all');
  }
}
